import React from 'react'
import { DocumentNode, useLazyQuery } from '@apollo/client'

interface FileDownloadButtonProps {
  querySelector: DocumentNode
  variables: {
    id?: string
    url: string
  }
  disabled?: boolean
}

const FileDownloadButton = (props: FileDownloadButtonProps): JSX.Element => {
  const { querySelector, variables, disabled } = props
  const [getFile, { loading }] = useLazyQuery(querySelector, {
    onCompleted: data => {
      const firstKey = Object.keys(data)[0]
      const fileData = data[firstKey]

      if (fileData && fileData.content) {
        const { content, filename, contentType } = fileData
        downloadFile(content, filename, contentType)
      }
    },
    onError: error => {
      console.error('Erreur lors du téléchargement', error)
    },
  })

  return (
    <button
      className="btn btn-sm btn-outline-primary"
      onClick={() => getFile({ variables })}
      disabled={disabled || loading}
      aria-label="Télécharger le fichier"
    >
      {loading ? (
        <i className="fa fa-spinner fa-spin" />
      ) : (
        <i className="fa fa-download" />
      )}
    </button>
  )
}

const downloadFile = (
  content: string,
  filename: string,
  contentType: string
) => {
  const link = document.createElement('a')
  link.href = `data:${contentType};base64,${content}`
  link.download = filename
  link.click()
  document.body.removeChild(link)
}

export { downloadFile }
export default FileDownloadButton
